import type { GaApp } from '~/modules/app'

export class MainService {
  gaApp: GaApp

  constructor(gaApp: GaApp) {
    this.gaApp = gaApp
  }
}
